
import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { Star } from 'lucide-react';

const BookmarkStar = ({ isBookmarked, onClick }) => {
  const [isBookmarksPage, setIsBookmarksPage] = useState(false);
  
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.location.pathname === '/bookmarks'
    ) {
      setIsBookmarksPage(true);
    }
  }, []);

  return (
    <button
      onClick={onClick}
      className='inline-flex items-center justify-center focus:outline-none'
    >
      <Star
        size={24} // Consistent size for both mobile and desktop
        fill={isBookmarksPage || isBookmarked ? '#AF52DE' : 'none'}
        color='#AF52DE'
        strokeWidth={1.5}
        className='transition-colors duration-300'
      />
    </button>
  );
};

export default dynamic(() => Promise.resolve(BookmarkStar), { ssr: false });